import { useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { formatApiError } from "../../lib/api";
import clienteApi, { CLI_TOKEN_KEY } from "../../lib/clienteApi";
import { ClienteBrand } from "./ClienteLogin";

export default function ClienteAccesso() {
  const [sp] = useSearchParams();
  const nav = useNavigate();
  const [err, setErr] = useState("");
  const done = useRef(false);
  useEffect(() => {
    if (done.current) return;
    done.current = true;
    clienteApi.post("/cliente-auth/magic-link/verify", { token: sp.get("token") || "" })
      .then(({ data }) => { localStorage.setItem(CLI_TOKEN_KEY, data.token); nav("/cliente", { replace: true }); })
      .catch((e) => setErr(formatApiError(e.response?.data?.detail)));
  }, [sp, nav]);
  return (
    <div className="min-h-screen flex items-center justify-center px-6 pgp-grid-bg" data-testid="cliente-accesso-page">
      <div className="w-full max-w-sm space-y-6">
        <ClienteBrand />
        {err ? (
          <div className="space-y-3">
            <p className="text-sm text-red-500" data-testid="cliente-accesso-error">{err}</p>
            <Link to="/cliente/login" className="text-sm text-amber-600 underline" data-testid="cliente-accesso-back">Torna all'accesso</Link>
          </div>
        ) : (
          <div className="flex items-center gap-2 text-sm text-slate-400"><Loader2 className="h-4 w-4 animate-spin" />Accesso in corso…</div>
        )}
      </div>
    </div>
  );
}
